module.exports = __webpack_public_path__ + "img/lianjiang-banner.df70c4a9.jpg";